import lazyLoading from './config';

export default [
    {
        path: '/',
        name: 'api.new',
        meta: {
            title: '爱库存-API文档'
        },
        component: resolve => lazyLoading(resolve, 'apiDoc/new')
    },
    {
        path: '/delivery',
        name: 'api.delivery',
        meta: {
            title: '爱库存-API文档'
        },
        component: resolve => lazyLoading(resolve, 'apiDoc/delivery')
    }
];
